 export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
      date = time;
    } else {
      if (("" + time).length === 10) time = parseInt(time) * 1000;
      date = new Date(time);
    }
    const formatObj = { 
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key];
      // Note: getDay() returns 0 on Sunday
      if (key === "a") {
        return '星期'+["日", "一", "二", "三", "四", "五", "六"][value];
      }
      if (result.length > 0 && value < 10) {
        value = "0" + value;
      }
      return value || 0;
    });
    return time_str;
  }
  export function getYears(start,end) {
    var yearList = [];
    var dateTime = new Date(); 
    var endYear = end?end:dateTime.getFullYear();// 获取当前年份 
    var startYear = start?start:1990;
    for (var i = startYear; i <= endYear; i++) { 
      yearList.unshift({
        'lable':i+'年',
        'value':i.toString()
      }); 
    } 
    return yearList;
  }
  export function getMonths() {
    var monthList = [];
    for (var i = 1; i <= 12; i++) { 
      monthList.unshift({
        'lable':i.toString()+'月',
        'value':i.toString().padStart(2,0)
      }); 
    } 
    return monthList;
  }


// WEBPACK FOOTER //
// ./src/filter/index.js